import React from 'react';

import SelectMessageBody from '../../components/SelectMessageBody';
import SelectTitle from '../../components/SelectTitle';
import SelectURL from '../../components/SelectURL';
import IData from '../../shared/IData';
import Styles from '../../lib/Styles';
import classes from './CampaignContent.module.scss';

export interface ICampaignContent {
    data: IData | undefined;
}

export default function CampaignContent(props: ICampaignContent ) {
  const { data } = props;
  const cx = new Styles(classes).cx;

  return (
    <div className={cx('root')}>
        <SelectTitle initialValue={data?.title}
                      selectedTitle={data?.title}
                      setSelectedTitle={() => {}}
                      onChangeTitle={() => {}}
                      readOnly={true} />
        <SelectMessageBody initialValue={data?.messageBody}
                      selectedMessageBody={data?.messageBody}
                      setSelectedMessageBody={() => {}}
                      onChangeMessageBody={() => {}}
                      readOnly={true} />
        <SelectURL    initialValue={data?.url}
                      selectedURL={data?.url}
                      setSelectedURL={() => {}}
                      onChangeURL={() => {}}
                      readOnly={true} />
    </div>
  );
};
